<template>
  <div class="crud_module--rsr_cancel_charger">
<!--    {{this.data.status}}-->
    <el-button v-if="checkStatus()" type="info"
               @click="$router.push({ name: 'Edit', params: { id: data.rsr_id} })"
    ><fa :icon="['fas', 'edit']"/></el-button>

  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {

  },
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
  },
  methods: {
    checkStatus(){
      if(this.data?.status == 'UnderPenalty' && this.data?.is_free !=='Y' ){
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      key: "",
      id:0,
      loading:false,
      connectors:[],
      input:{
        connectorId:0,
        duration:0,
        startCode:"",
        lp:"",
        entryTime:""
      },
    }
  }
}
</script>